export default "__VITE_ASSET__65deb84e__"